import React, { useEffect, useState } from "react"
import { useIntl } from "gatsby-plugin-intl"

import { Link } from "../../Link"
import styles from "./Footer.module.scss"
import Logo from "../../../assets/images/logo.svg"

import Facebook from "../../../assets/images/icons/facebook-icon.svg"
import Instagram from "../../../assets/images/icons/inst-icon.svg"
import Linkedin from "../../../assets/images/icons/linkedin-icon.svg"

interface FooterProps {
	pathname?: string
}

const Footer: React.FC<FooterProps> = ({ pathname = "" }) => {
	const intl = useIntl()
	const dir = "ltr"
	const [currentPath, currentPathSetter] = useState<string>("")

	useEffect(() => {
		if (!pathname) return
		const path = pathname.split("/")[2]
		if (path) {
			currentPathSetter(`/${path}/`)
		}
	}, [pathname])



	const footerInf = [
		intl.formatMessage({ id: "footer.info.first" }),
		intl.formatMessage({ id: "footer.info.second" }),
		intl.formatMessage({ id: "footer.info.third" })
	]

	const menuItems = [
		{ name: "main", path: "/", translatePath: "footer.navigation.main", },
		{ name: "projects", path: "/projects/", translatePath: "footer.navigation.projects", },
		{ name: "blog", path: "/blog/", translatePath: "footer.navigation.blog", },

	]

	const servicesItems = [
		{ name: "full-cycle-development", path: "/full-cycle-development", translatePath: "footer.navigation.full-cycle-development", },

	]

	const generalItems = [
		{ name: "about", path: "/about/", translatePath: "footer.navigation.about", },
		{ name: "career", path: "/career/", translatePath: "footer.navigation.career", },
		{ name: "press", path: "/press/", translatePath: "footer.navigation.press" },
		{ name: "sitemap", path: "/sitemap/", translatePath: "footer.navigation.sitemap", },
	]

	return (
		<footer id="contact-form">
			<section className={styles.footer}>
				<div className={styles.container}>
					<div className={styles.footerAddressBlock}>
						<Link to="/" >
							<img
								src={Logo}
								alt="Inventale logo"
								width="229"
								height="53"
							/>
						</Link>
						<div>
							<a className={styles.footerAddress}
								href="https://maps.app.goo.gl/P3hw76Srm5Rx7UXRA" target="_blank"
							>
								{intl.formatMessage({ id: "footer.info.address.text" })}
							</a>
							{
								footerInf.map(infText => {
									const infTextTrim = infText.trim();
									if (infTextTrim !== '') {
										return (
											<p>
												{infTextTrim}
											</p>
										)
									}
								})
							}
						</div>
					</div>
					<nav className={styles.navigation}>
						<div>
							<h4 className={styles.navigationTitle}>
								{intl.formatMessage({ id: "footer.navigation.sitemap" })}
							</h4>
							<ul className={styles.navigationList}>
								{menuItems.map((item, index) => (
									<li
										key={index}
										className={styles.navigationItem}
										data-name={item.name}
									>
										<Link
											to={
												item.name === "blog"
													? item.path.replace("{locale}", intl.locale)
													: item.path
											}
										>
											{intl.formatMessage({ id: item.translatePath })}
										</Link>
									</li>
								))}
							</ul>
						</div>
						<div>
							<h4 className={styles.navigationTitle}>
								{intl.formatMessage({ id: "footer.navigation.services-title" })}
							</h4>
							<ul className={styles.navigationList}>
								{servicesItems.map((item, index) => (
									<li
										key={index}
										className={styles.navigationItem}
										data-name={item.name}
									>
										<Link to={item.path}>
											{intl.formatMessage({ id: item.translatePath })}
										</Link>
									</li>
								))}
							</ul>
						</div>
						<div>
							<ul className={styles.navigationList}>
								<h4 className={styles.navigationTitle}>
									{intl.formatMessage({ id: "footer.navigation.company" })}
								</h4>
								{generalItems.map((item, index) => (
									<li
										key={index}
										className={styles.navigationItem}
										data-name={item.name}
									>
										<Link to={item.path}>
											{intl.formatMessage({ id: item.translatePath })}
										</Link>
									</li>
								))}
							</ul>
						</div>
					</nav>
					<div className={styles.footerSocial}>
						<div className={styles.footerSocialButtons}>
							<a href="https://www.facebook.com/inventale" target="blank">
								<img src={Facebook} alt="facebook" />
							</a>
							<a href="https://www.instagram.com/invenpro.tech/" target="blank">
								<img src={Instagram} alt="Instagram" />
							</a>
							<a href="https://www.linkedin.com/company/76620891/" target="blank">
								<img src={Linkedin} alt="Linkedin" />
							</a>
						</div>
						<Link to="/personal-data-processing/">{intl.formatMessage({ id: "footer.navigation.policy" })}</Link>
					</div>
				</div>
			</section>
		</footer>
	)
}

export default Footer
